export default {"src":"/_next/static/media/ltc.83a77e5e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};